export const faqs = [
  {
    question: "What areas do you serve?",
    answer: "We currently serve the greater metropolitan area and surrounding counties. Contact us to check availability in your specific location."
  },
  {
    question: "Are your caregivers licensed and insured?",
    answer: "Yes, all our caregivers are fully licensed, insured, bonded, and undergo thorough background checks before joining our team."
  },
  {
    question: "How do you match caregivers with clients?",
    answer: "We carefully assess each client's needs, preferences, and personality to match them with the most suitable caregiver for a comfortable and effective care experience."
  },
  {
    question: "What is the cost of homecare services?",
    answer: "Costs vary based on the type and duration of care needed. We offer a free consultation to assess your needs and provide a transparent, customized quote."
  },
  {
    question: "Can I change or cancel my care plan?",
    answer: "Absolutely. We understand that needs change. You can modify or cancel your care plan at any time with reasonable notice."
  }
];
